import Image from "@elements/ResponsiveImage/Image";
import { colorConstants } from "@helper/sectionConstants";
import { twMerge } from "tailwind-merge";

import ArticleCarouselFooter from "./ArticleCarouselFooter";

type ArticleImageProps = {
  url?: string;
  width?: number;
  height?: number;
  sectionName?: string;
  caption: string;
  credit: string;
  alt: string;
  index?: string;
  className?: string;
  currentSlideCount?: number;
  totalSlideCount?: number;
};

export default function ArticleImage({
  alt,
  url,
  width = 825,
  height = 550,
  caption,
  credit,
  index,
  className,
  currentSlideCount,
  totalSlideCount,
  sectionName,
}: ArticleImageProps) {
  const sectionColor =
    sectionName && sectionName in colorConstants
      ? colorConstants[sectionName as keyof typeof colorConstants].color.lightBg
      : "";

  return (
    <div className={twMerge("mb-4", className)} key={index}>
      <div className="w-full">
        <Image
          src={url ?? ""}
          displayWidth={width}
          srcWidth={width}
          srcHeight={height}
          alt={alt}
        />
        {caption && (
          <ArticleCarouselFooter
            caption={caption}
            credit={credit}
            currentSlideCount={currentSlideCount}
            totalSlideCount={totalSlideCount}
            sectionColor={sectionColor}
          />
        )}
      </div>
    </div>
  );
}
